import { Dialog } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { getEmployees } from "../../../services/getEmployees";
import { term } from "../../../terms";
import InputTextModal from "../modalGeneralComponents/InputTextModal";
import AssignedEmployeesListBox from "../updateClientServiceSubscriptionTaskModal/AssignedEmployeesListBox";
import ButtonModal from "../updateClientServiceSubscriptionTaskModal/ButtonModal";
import ErrorMessage from "../updateClientServiceSubscriptionTaskModal/ErrorMessage";
import { usePermissions } from "../../../context/PermissionsContext";

const AddNewClientServiceSubscriptionTask = ({
    open,
    setOpen,
    AddNewTask,
    clientServiceId,
}) => {
    const { can, permissionsLoading } = usePermissions();
    const canWriteSteps = can("steps.write");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [newClientServiceSubscriptionTask, setNewClientServiceSubsriptionTask] =
        useState({ name: "", assignedEmployees: [] });
    const [errors, setErrors] = useState({});

    let completeButtonRef = useRef(null);

    const isObjectEmpty = (objectName) => {
        return Object.keys(objectName).length === 0;
    };

    const cleanInputs = () => {
        setNewClientServiceSubsriptionTask({
            name: "",
            assignedEmployees: [],
            serviceStatus: {},
        });
        setErrors({});
    };

    /* const onHandleChangeServiceStatus = (newServiceStatus) => {
    if (isObjectEmpty(newServiceStatus)) {
      setErrors({
        ...errors,
        serviceStatus: "This field cannot be empty.",
      });
    } else {
      setErrors({});
    }
    setNewClientServiceSubsriptionTask({
      ...newClientServiceSubscriptionTask,
      serviceStatus: newServiceStatus,
    });
  };
 */
    const onHandleChange = (e) => {
        const fieldName = e.target.name;
        const fieldValue = e.target.value;
        setNewClientServiceSubsriptionTask({
            ...newClientServiceSubscriptionTask,
            [fieldName]: fieldValue,
        });
    };
    const onHandleCancel = () => {
        cleanInputs();
        setOpen(false);
    };
    const onHandleSubmit = async (e) => {
        e.preventDefault();
        if (permissionsLoading || !canWriteSteps || isSubmitting) return;
        if (validateForm(newClientServiceSubscriptionTask)) {
            setIsSubmitting(true);
            try {
                await AddNewTask(newClientServiceSubscriptionTask);
                cleanInputs();
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    const onHandleChangeAssignedEmployees = (newAssignedEmployees) => {
        if (isObjectEmpty(newAssignedEmployees)) {
            setErrors({
                ...errors,
                assignedEmployees: "This field cannot be empty.",
            });
        } else {
            setErrors({});
        }
        setNewClientServiceSubsriptionTask({
            ...newClientServiceSubscriptionTask,
            assignedEmployees: newAssignedEmployees,
        });
    };

    const validateForm = (form) => {
        let validation = true;
        /*  if (isObjectEmpty(form.serviceStatus)) {
      setErrors({ ...errors, serviceStatus: "This field cannot be empty." });
      validation = false;
    } */
        if (isObjectEmpty(form.assignedEmployees)) {
            setErrors({
                ...errors,
                assignedEmployees: "This field cannot be empty.",
            });
            validation = false;
        }
        console.log(errors);
        return validation;
    };

    const getNewEmployees = async () => {
        if (permissionsLoading || !canWriteSteps) return;
        const response = await getEmployees();
        setEmployees(response.data.employees);
    };

    /* const getServiceStatuses = async () => {
    const response = await getClientServiceSubscriptionStateItemsByServiceId(
      clientServiceId
    );
    setServiceStatuses(response.data.serviceStatuses);
  }; */
    useEffect(() => {
        getNewEmployees();
        /*     getServiceStatuses();
         */
    }, [canWriteSteps, permissionsLoading]);

    return (
        <AnimatePresence>
            {open && (
                <Dialog
                    initialFocus={completeButtonRef}
                    static
                    as={motion.div}
                    open={open}
                    onClose={() => setOpen(false)}
                    className="relative z-50"
                >
                    {/* The backdrop, rendered as a fixed sibling to the panel container */}
                    <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

                    {/* Full-screen scrollable container */}
                    <div className="fixed inset-0 w-screen overflow-y-auto">
                        {/* Container to center the panel */}
                        <div className="flex items-center justify-center min-h-full p-4">
                            <Dialog.Panel className="relative w-full px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:p-6">
                                <Dialog.Title className="w-full text-lg font-medium leading-6 text-center text-gray-900">
                                    Add Custom {term("step_singular")}
                                </Dialog.Title>

                                <form onSubmit={onHandleSubmit}>
                                    <InputTextModal
                                        required={true}
                                        label="Name *"
                                        name="name"
                                        onChange={onHandleChange}
                                        value={newClientServiceSubscriptionTask.name}
                                    />

                                    <AssignedEmployeesListBox
                                        title="Assigned Employees *"
                                        employees={employees}
                                        assignedEmployees={
                                            newClientServiceSubscriptionTask.assignedEmployees
                                        }
                                        onChange={onHandleChangeAssignedEmployees}
                                    />
                                    <ErrorMessage
                                        error={errors["assignedEmployees"]}
                                    />

                                    {/* <ServiceStatusesListBox
                    label="Service Status *"
                    serviceStatuses={serviceStatuses}
                    selectedServiceStatus={
                      newClientServiceSubscriptionTask.serviceStatus
                    }
                    onChange={onHandleChangeServiceStatus}
                  />
                  <ErrorMessage error={errors["serviceStatus"]} /> */}

                                    <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                        <ButtonModal
                                            name="Save"
                                            type="submit"
                                            className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-teal-500 border border-transparent rounded-md shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-0 sm:col-start-2 sm:text-sm"
                                            disabled={
                                                permissionsLoading ||
                                                !canWriteSteps ||
                                                isSubmitting
                                            }
                                        />
                                        <ButtonModal
                                            name="Cancel"
                                            type="button"
                                            onClick={onHandleCancel}
                                            className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-0 sm:mt-0 sm:col-start-1 sm:text-sm"
                                        />
                                    </div>
                                </form>
                            </Dialog.Panel>
                        </div>
                    </div>
                </Dialog>
            )}
        </AnimatePresence>
    );
};

export default AddNewClientServiceSubscriptionTask;
